import Vue from "vue";
import VueI18n from "vue-i18n";

import * as EN from './en'
import * as ID from './id'
import * as PT from './pt'
import * as ES from './es'
import * as AR from './ar'
import * as TR from './tr'
import * as FR from './fr'
import Client from "@/assets/scripts/client";

Vue.use(VueI18n);

const messages = {
  'en': Object.assign(EN), // 英文
  'id': Object.assign(ID), // 印尼
  'pt': Object.assign(PT), // 葡萄牙语
  'es': Object.assign(ES), // 西班牙语
  'ar': Object.assign(AR), // 阿拉伯语
  'tr': Object.assign(TR), // 土耳其语
  'fr': Object.assign(FR), // 法语
};

export function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  if (lang == 'ar') {
    document.querySelector('html').setAttribute('dir', 'rtl');
  } else {
    document.querySelector('html').removeAttribute('dir')
  }
  return lang;
}

export function getLanguage () {
  const chooseLanguage = Client.getAppInfoLang();
  if (chooseLanguage) {
    return chooseLanguage;
  }
  return '';
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});

export default i18n;
